export const ThemeVariants = Object.freeze({
    Dark: 'dark',
    Light: 'light'
});

export type ThemeVariant = (typeof ThemeVariants)[keyof typeof ThemeVariants];
